import * as D from './deps';

export const DOMAIN_NAME = 'sample' as const;

export const SAMPLE_DURATION_SEC = 30 as const;
export const SAMPLE_ENCODING = D.AudioConstants.AudioEncodingFormats.MP3;

// Keys specific to sample playback that doesn't apply to audio playback
export const SamplePlayerKeys = Object.freeze({
  SHOULD_RESUME_TRACK: 'SHOULD_RESUME_TRACK',
} as const);
